export const FIELD_SINGLE_LINE_TEXT = 'Single-line text';
export const FIELD_MULTI_LINE_TEXT = 'Multi-line text';
export const FIELD_NUMBER = 'Number';
export const FIELD_DROPDOWN_SELECT = 'Dropdown select';
export const FIELD_DATE_PICKER = 'Date picker';
export const FIELD_SINGLE_CHECKBOX = 'Single checkbox';
export const FIELD_MULTIPLE_CHECKBOXES = 'Multiple checkboxes';
export const FIELD_RADIO_SELECT = 'Radio select';
export const CUSTOM_FIELDS = [
    FIELD_SINGLE_LINE_TEXT,
    FIELD_MULTI_LINE_TEXT,
    FIELD_NUMBER,
    FIELD_DROPDOWN_SELECT,
    FIELD_DATE_PICKER,
    FIELD_SINGLE_CHECKBOX,
    FIELD_MULTIPLE_CHECKBOXES,
    FIELD_RADIO_SELECT
];
export const FIELD_COMPONENT_MAP = [
    {
        field: FIELD_SINGLE_LINE_TEXT,
        component: 'GInput'
    },
    {
        field: FIELD_MULTI_LINE_TEXT,
        component: 'GTextArea'
    },
    {
        field: FIELD_NUMBER,
        component: 'GInput',
        props: {
            type: 'number'
        }
    },
    {
        field: FIELD_DROPDOWN_SELECT,
        component: 'GSelect'
    },
    {
        field: FIELD_DATE_PICKER,
        component: 'GDatePicker'
    },
    {
        field: FIELD_SINGLE_CHECKBOX,
        component: 'GCheckbox'
    },
    {
        field: FIELD_MULTIPLE_CHECKBOXES,
        component: 'GCheckboxGroup'
    },
    {
        field: FIELD_RADIO_SELECT,
        component: 'GRadioGroup'
    }
];
